import { useCallback, useEffect, useRef } from 'react';

const useCancellableAnimationFrame = () => {
  const animationFrameIdRef = useRef(null);

  const cancelNextFrame = useCallback(() => {
    if (animationFrameIdRef.current) {
      cancelAnimationFrame(animationFrameIdRef.current);
      animationFrameIdRef.current = null;
    }
  }, []);

  const requestNextFrame = useCallback(
    (callback) => {
      cancelNextFrame();
      animationFrameIdRef.current = requestAnimationFrame(() => {
        animationFrameIdRef.current = null;
        callback?.();
      });
    },
    [cancelNextFrame]
  );

  useEffect(() => {
    return () => {
      cancelNextFrame();
    };
  }, [cancelNextFrame]);

  return { requestNextFrame, cancelNextFrame };
};

export default useCancellableAnimationFrame;
